export default "__VITE_ASSET__CoWedngC__"